<div *ngIf='componentReady' class='CommunicationContent p-0 p-sm-3'>
  <div class='CommunicationContent-info mb-4'>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Create Content</mat-panel-title>
        </mat-expansion-panel-header>
        <p>
          <strong>INSTRUCTIONS:</strong> Now we are going to create your content.
          Retreva® will create the emails for you. However, it is important that
          you spend some time creating your attention and benefit statements.
        </p>
        <p class='font-weight-bolder'>Things to think about:</p>
        <ul>
          <li>
            Each statement should be able to stand alone or with other statements.
            They need to make sense in any particular order.
          </li>
          <li>
            All statements should focus on the benefit your service or product
            provides customers and not about why your product is superior or the
            best in the marketplace.
          </li>
          <li>
            All statements should be general and should not make statements directed
            at the contact like “your competitors” or what this will do for "you"
          </li>
        </ul>
        <p>
          Additionally, if you feel your product or service requires you attach a
          bunch of details, they should be created in bullets and Retreva® will
          attach them at the bottom of the email
        </p>
        <div class='CommunicationContent-info-help'>
          <div class='row'>
            <div class='col col-12 col-sm-6'>
              <app-button
                (click)='openExamplesDialog()'
                [color]="'blue'"
                [size]="'small'"
                [style]="'outline'"
                [text]="'click here for examples'"></app-button>
            </div>
            <div class='col col-12 col-sm-6'>
              <span class='CommunicationContent-info-help-hint'
              ><strong>Hint</strong>, you can usually find great content on your
                existing marketing materials or website</span
              >
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div class='CommunicationContent-info'>
    <div class='CommunicationContent-form'>
      <div
        *ngIf='validationError'
        class='alert alert-danger alert-dismissible fade show'
        role='alert'>
        Please, fill all required fileds in red
        <button
          aria-label='Close'
          class='btn-close'
          data-bs-dismiss='alert'
          type='button'></button>
      </div>
      <form [formGroup]='formGroup'>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Content code</h5>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row mt-3'>
              <div class='col col-12 col-sm-8'>
                <div class='row'>
                  <div class='col col-12 col-sm-6'>
                    <mat-label>Content Code:</mat-label>
                  </div>
                  <div class='col col-12 col-sm-6'>
                    <app-text-field
                      formControlName='content_code'
                      placeholder='Content Code'></app-text-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class='CommunicationContent-form-row-content mt-3'>
            <div class='row'>
              <div class='col col-12 col-sm-8'>
                <div class='row'>
                  <div class='col col-12 col-sm-6'>
                    <mat-label>Select Existing Content:</mat-label>
                  </div>
                  <div class='col col-12 col-sm-6'>
                    <app-select
                      (selection)='onContentSelect($event)'
                      [defaultValue]='selection'
                      [items]='contentItems'
                      [label]='selectContentProperties.label'></app-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Get started with you content:</h5>
            <app-info-tip-button
              [type]="'get_started_with_content'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <p>Choose a Goal:</p>
                  <div>
                    <mat-radio-group
                      aria-label='Select a goal'
                      formControlName='campaign_goal'>
                      <mat-radio-button class='me-2' value='phone'
                      >Phone call
                      </mat-radio-button
                      >
                      <mat-radio-button class='me-2 mt-3 mt-sm-0' value='face'
                      >Meeting
                      </mat-radio-button
                      >
                      <mat-radio-button class='me-2 mt-3 mt-sm-0' value='website'
                      >Checking In
                      </mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Fill in the blank:</h5>
            <app-info-tip-button
              [type]="'fill_in_the_blank'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <p>
                    I would like to learn more about your ______ (e.g. IT
                    infrastructure, hiring process, advertising goals, etc. DO
                    NOT CAPITALIZE, unless it would always be written with
                    capitalization.)
                  </p>
                  <app-text-field
                    formControlName='quick_answer'
                    placeholder='Fill...'></app-text-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Select Greeting:</h5>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <p>Greeting</p>
                  <div>
                    <app-text-field
                      *ngIf='showCustomGreeting'
                      formControlName='custom_greeting'
                      placeholder='Enter greeting'></app-text-field>
                    <app-button
                      *ngIf='showCustomGreeting'
                      [Click]='backToGreetingsButton.onClick'
                      [color]='backToGreetingsButton.color'
                      [size]='backToGreetingsButton.size'
                      [text]='backToGreetingsButton.text'></app-button>
                    <app-select
                      (selection)='onGreetingsSelection($event)'
                      *ngIf='!showCustomGreeting'
                      [items]='greetingsSelect.items'
                      [label]='greetingsSelect.label'
                      formControlName='greeting'></app-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Create an attention statement:</h5>
            <app-info-tip-button
              [type]="'attention_statement'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <p>Why should customer buy your service/product ?</p>
                  <div class=''>
                    <app-editor formControlName='content_attention'></app-editor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Create 2 benefit statements:</h5>
            <app-info-tip-button
              [type]="'explain_benefits'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <div>
                    <p>Benefit 1:</p>
                    <app-editor formControlName='first_benefit'></app-editor>
                  </div>
                  <div class='mt-3'>
                    <p>Benefit 2:</p>
                    <app-editor formControlName='second_benefit'></app-editor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Detailed Section:</h5>
            <app-info-tip-button
              [type]="'detailed_section'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <p>Details</p>
                  <div>
                    <app-editor formControlName='content_details'></app-editor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class='CommunicationContent-form-row d-flex flex-row justify-content-end'>
          <app-button
            [color]='backButton.color'
            [route]='backButton.route'
            [size]='backButton.size'
            [style]='backButton.style'
            [text]='backButton.text'
            class='CommunicationContent-form-controls-button'></app-button>
          <app-button
            [Click]='previewButton.onClick'
            [color]='previewButton.color'
            [size]='previewButton.size'
            [style]='previewButton.style'
            [text]='previewButton.text'
            class='CommunicationContent-form-controls-button'></app-button>
        </div>
      </form>
    </div>
  </div>
</div>
